<template>
  <div id="fee_main">
    <div class="main">
      <TitleBar
        :title="feeTypeName"
        :introduction="{
          link: 'https://www.smartdaily.com.tw/mau/',
          product_id: 'management_fee',
          product_name: '管理費',
          subpage_name: tabName
        }"
        :tip="`建立${feeTypeName}繳費明細`"
      >
        <template #btns>
          <el-button
            icon="icon-setting"
            round
            @click="editConfig=true"
          >
            設定
          </el-button>
        </template>
      </TitleBar>
      <fee-tabs
        ref="feeTabs"
        :config-data="configData"
        :period-data="periodData"
        :period-data-new="periodDataNew"
        @updatePeriod="getPeriodList(false)"
      />
      <div class="tabContent">
        <router-view
          v-loading.fullscreen.lock="pageLoading"
          :period-data="periodData"
          :period-data-new="periodDataNew"
          :config-data="configData"
          :period-data-end="periodDataEnd"
          :period-loading="periodLoading"
          @getMorePeriod="autoShowPeriodList"
          @updatePeriod="getPeriodList(false)"
        />
      </div>
    </div>
    <el-dialog
      title="設定"
      :visible.sync="editConfig"
      :close-on-click-modal="false"
      :show-close="false"
      :lock-scroll="true"
      center
      @closed="resetForm('feeConfigEdit')"
    >
      <el-form
        ref="feeConfigEdit"
        :model="configData.CommunityBillBulkTemplate"
        status-icon
        :rules="editRule"
        class="demo-ruleForm"
        @submit.native.prevent
      >
        <div class="basicSetting">
          <div class="block">
            <div class="block_left">
              <h4>繳費單</h4>
              <el-button
                size="mini"
                plain
                @click="handlePreview('bill')"
              >
                預覽
              </el-button>
            </div>
            <div class="block_right">
              <el-form-item
                class="half"
                label="社區名稱"
                prop="CommitteeInfoName"
              >
                <el-input
                  v-model="configData.CommunityBillBulkTemplate.CommitteeInfoName"
                  size="small"
                  maxlength="20"
                  placeholder="限20字"
                />
              </el-form-item>
              <el-form-item
                class="half"
                label="社區電話"
                prop="CommitteeInfoTel"
              >
                <el-input
                  v-model="configData.CommunityBillBulkTemplate.CommitteeInfoTel"
                  size="small"
                  maxlength="15"
                  placeholder="限15字"
                />
              </el-form-item>
              <el-form-item
                label="社區地址"
                prop="CommitteeInfoAddress"
              >
                <el-input
                  v-model="configData.CommunityBillBulkTemplate.CommitteeInfoAddress"
                  size="small"
                  maxlength="45"
                  placeholder="限45字"
                />
              </el-form-item>
              <el-form-item
                label="繳費方式"
                prop="CommunityPayWay"
              >
                <el-checkbox-group
                  v-model="configData.checkList"
                  class="whole"
                >
                  <el-checkbox
                    v-for="(val) in configData.CommunityPayWay"
                    :key="val.Id"
                    :label="val.ConfigPayWayId"
                    :value="val.Switch"
                    :disabled="val.ConfigPayWayId!='ConvenienceStore' && val.ConfigPayWayId!='CreditCard' || !configData.ConfigCommunityCodeRuleIsExisting"
                  >
                    {{ val.ConfigPayWayShowName }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item prop="ConfigHandlingFeeModeId" class="independent">
                <template slot="label">
                  <span class="click-label" @click="isShowFeeDescription = !isShowFeeDescription">
                    {{ $t("Fee.FeeDescription") }}
                    <i class="icon-arrow-right2" :class="{rotate: isShowFeeDescription}"></i>
                  </span>
                </template>
                <transition name="collapse">
                  <div v-show="isShowFeeDescription">
                    <FeeDescription />
                  </div>
                </transition>
              </el-form-item>
              <el-form-item label="期別備註">
                <el-input
                  v-model="configData.CommunityBillBulkTemplate.BillBulkNote"
                  type="textarea"
                  maxlength="80"
                  :autosize="{ minRows: 3}"
                  placeholder="限80字"
                  resize="none"
                />
                <span class="num">{{ configData.CommunityBillBulkTemplate.BillBulkNote.length || 0 }}/80</span>
              </el-form-item>
              <el-form-item label="期別通訊欄">
                <el-input
                  v-model="configData.CommunityBillBulkTemplate.BillBulkCommunicationBar"
                  type="textarea"
                  maxlength="150"
                  :autosize="{ minRows: 3}"
                  placeholder="限150字，期別通訊欄＋戶別通訊欄最多顯示12行"
                  resize="none"
                />
                <span class="num">{{ configData.CommunityBillBulkTemplate.BillBulkCommunicationBar.length || 0 }}/150</span>
              </el-form-item>
            </div>
          </div>
          <div class="block">
            <div class="block_left">
              <h4>收據</h4>
              <el-button
                size="mini"
                plain
                @click="handlePreview('receipt')"
              >
                預覽
              </el-button>
            </div>
            <div class="block_right">
              <el-form-item label="收據開立注意事項">
                <el-input
                  v-model="configData.CommunityBillBulkTemplate.ReceiptNotice"
                  type="textarea"
                  maxlength="250"
                  :autosize="{ minRows: 3}"
                  placeholder="限250字，最多顯示5行"
                  resize="none"
                />
                <span class="num">{{ configData.CommunityBillBulkTemplate.ReceiptNotice.length || 0 }}/250</span>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          round
          @click="handleCancelEdit()"
        >取消</el-button>
        <el-button
          type="primary"
          round
          @click="handleSaveEdit('feeConfigEdit')"
        ><span>儲存</span><span v-show="!isDataEqual(configData.CommunityPayWay,configDataOri.CommunityPayWay)">(繳費方式、手續費扣繳的更動將套用到所有未啟用的期別)</span></el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import TitleBar from '@/components/PageTitleBar.vue'
import FeeTabs from '@/components/FeeTabs'
import FeeDescription from './components/FeeDescription.vue'
export default {
  components: {
    TitleBar,
    'fee-tabs': FeeTabs,
    FeeDescription
  },
  data () {
    const validatePhone = (rule, value, callback) => {
      const pattern = new RegExp(/^[0-9]{0,15}$/)
      if (value.toString().length === 0) {
        callback()
      } else if (!value.toString().match(pattern)) {
        callback(new Error('請輸入正確格式'))
      } else {
        callback()
      }
    }
    return {
      pageLoading: false,
      periodData: [],
      offset: 0,
      limit: 30,
      periodDataEnd: false,
      periodLoading: false,
      periodDataNew: 0,
      configDataFirst: false,
      configData: {
        CommunityBillBulkTemplate: {
          CommitteeInfoName: '',
          CommitteeInfoAddress: '',
          CommitteeInfoTel: '',
          BillBulkNote: '',
          BillBulkCommunicationBar: '',
          ReceiptNotice: ''
        },
        CommunityPayWay: []
      },
      configDataOri: {},
      editConfig: false,
      editRule: {
        CommitteeInfoName: [
          { required: true, message: '請輸入社區名稱', trigger: 'change' }
        ],
        CommitteeInfoAddress: [
          { required: true, message: '請輸入社區地址', trigger: 'change' }
        ],
        CommitteeInfoTel: [
          { required: true, message: '請輸入社區電話', trigger: 'change' },
          { validator: validatePhone, trigger: 'change' }
        ]
      },
      feeType: 'management',
      isShowFeeDescription: false
    }
  },
  computed: {
    feeTypeName () {
      switch (this.feeType) {
        case 'other-management':
          return '其他費用'
        case 'management':
          return '管理費'
        default:
          return '管理費'
      }
    },
    tabName () {
      const routeName = this.$route.name
      switch (routeName) {
      case 'FeePeriodList':
        return '期別列表'
      case 'FeePaymentList':
        return '繳費列表'
      case 'FeeDeposit':
        return '入帳報表'
      case 'FeeWriteoffErr':
        return '異常入帳款項'
      default:
        return ''
      }
    }
  },
  watch: {
    configData (val) {
      this.$store.dispatch('FeeUpdateConfig', val).then(() => {
        console.log(this.$store.state.fee)
      })
    },
    'configData.checkList' (configs) {
      this.configData.CommunityPayWay.forEach(element => {
        if (configs.indexOf(element.ConfigPayWayId) > -1) {
          element.Switch = true
        } else {
          element.Switch = false
        }
      })
    }
  },
  mounted () {
    this.pageLoading = true
    this.getPeriodList(false)
    this.getConfigData()
    this.feeType = this.$route.params.type
  },
  methods: {
    autoShowPeriodList () {
      this.$handleScroll(this.getPeriodList)
    },
    getPeriodList (getMore = true) { // 取得期別列表
      if (getMore) {
        this.periodLoading = true
      } else {
        this.pageLoading = true
      }
      if (!getMore) {
        this.offset = 0
      } else {
        this.offset += this.limit
      }
      const requestData = {
        limit: this.limit,
        offset: this.offset
      }
      return apiBillservice.BillBulk.GetBillBulkList(
        requestData
      ).then(async (res) => {
        await this.$sleep(1000, res.duration)
        // eslint-disable-next-line eqeqeq
        if (res.data.Data && (this.offset > 0 || (this.offset == 0 && res.data.Data.length > 0))) {
          console.log(res.data.Data.length)
          if (res.data.Data.length >= this.limit) {
            this.periodDataEnd = false
          } else {
            this.periodDataEnd = true
          }
          console.log(this.periodDataEnd)
          const oriPeriodData = res.data.Data.map((e) => {
            e.LastEntryDate = this.$formatDate(e.LastEntryDate)
            e.BillBulkCreateDate = this.$formatDate(e.BillBulkCreateDate)
            e.BillsActualAmountString = isNaN(Number(e.BillsActualAmount)) ? e.BillsActualAmount : Number(e.BillsActualAmount).toLocaleString()
            e.BillsShouldAmountString = isNaN(Number(e.BillsShouldAmount)) ? e.BillsShouldAmount : Number(e.BillsShouldAmount).toLocaleString()

            e = Object.assign({}, e, {
              PayRate: `${e.PaymentsCount}/${e.BillsCount}`,
              PayFeeRate: `${e.BillsActualAmount || 0}/${e.BillsShouldAmount || 0}`,
              EntryDue: new Date().getTime() - new Date(e.LastEntryDate).getTime() > 0
            })
            switch (e.BillBulkStatus) {
              case '未啟用':
                e.StatusColor = 'danger'
                e.StatusText = '未啟用'
                break
              case '開啟':
                e.StatusColor = 'success'
                e.StatusText = '啟用中'
                break
              case '關閉':
                e.StatusText = '已關閉'
                break
              default:
                e.StatusText = ''
            }
            return e
          }).filter((ele) => {
            // eslint-disable-next-line eqeqeq
            if (ele.BillBulkStatus != '刪除') {
              return ele
            }
          })
          if (getMore) {
            this.periodData = [...this.periodData, ...oriPeriodData]
          } else {
            this.periodData = _cloneDeep(oriPeriodData)
          }
          const sortPeriod = _cloneDeep(this.periodData)
          sortPeriod.sort(function (a, b) {
            return b.BillBulkId - a.BillBulkId
          })
          this.periodDataNew = sortPeriod[0].BillBulkId ? sortPeriod[0].BillBulkId : 0
        } else {
          this.periodData = res.data.Data
          this.periodDataEnd = true
        }
        const ScrollHeight = document.documentElement.scrollHeight
        // eslint-disable-next-line eqeqeq
        if (this.offset == 0) {
          document.documentElement.scrollTo(0, 0)
        } else {
          document.documentElement.scrollTo(0, ScrollHeight - 1500)
        }
        this.pageLoading = false
        this.periodLoading = false
        return true
      }).catch(async (err) => {
        console.log(err)
        console.log(err.response)
        // eslint-disable-next-line eqeqeq
        if (err.response.data.ErrorMessage && err.response.data.ErrorMessage.Description == 'Error getting value from \'ConfigPayWayShowName\' on \'BillService.Library.Models.Get.GetSnapshotCommunityPayWay\'.') {
          try {
            await apiBillservice.Config.PutSnapshotCommunityPayWays3_0To3_1()
            await apiBillservice.Config.PutSnapshotCommunityCodeRule3_0To3_1()
            this.pageLoading = false
            this.periodLoading = false
            location.reload()
          } catch {
            this.$message({
              message: '取得期別列表失敗，請稍後再試',
              type: 'warning'
            })
            this.pageLoading = false
            this.periodLoading = false
          }
        } else {
          this.$message({
            message: '取得期別列表失敗，請稍後再試',
            type: 'warning'
          })
          this.pageLoading = false
          this.periodLoading = false
        }
        return false
      })
    },
    getConfigData () { // 取得社區基本設定
      apiBillservice.Config.GetCommunitySettingForm(
      ).then((res) => {
        if (res.data.Data) {
          const checkArray = res.data.Data.CommunityPayWay.map(element => {
            if (element.Switch) {
              return element.ConfigPayWayId
            }
          }).filter(element => {
            return element !== undefined
          })
          this.configData = Object.assign({}, res.data.Data, { checkList: _cloneDeep(checkArray) })
          this.configDataOri = _cloneDeep(this.configData)
        }
      }).catch((err) => {
        console.log(err.response)
        // eslint-disable-next-line eqeqeq
        if (err.response && err.response.data.Status == 0) { // 未設定過config
          this.configData = Object.assign({}, this.configData, { checkList: [] })
          this.configData = Object.assign({}, this.configData, { checkList: [] })
          this.configDataOri = _cloneDeep(this.configData)
          this.configDataFirst = true
        } else {
          this.$message({
            message: '取得社區基本設定失敗，請稍後再試',
            type: 'warning'
          })
          console.log(err.response)
        }
      })
    },
    handleCancelEdit () { // 社區基本設定 - 取消編輯
      this.configData = _cloneDeep(this.configDataOri)
      this.editConfig = false
      console.log(_isEqual(this.configData, this.configDataOri))
    },
    handleSaveEdit (formName) { // 社區基本設定 - 儲存編輯
      console.log('saved')
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!_isEqual(this.configData, this.configDataOri)) {
            if ((!_isEqual(this.configData.CommunityPayWay, this.configDataOri.CommunityPayWay))) { // 更改繳費方式or更改手續費扣繳方式

            }
            this.pageLoading = true
            const requestData = {
              CommunityBillBulkTemplate: this.configData.CommunityBillBulkTemplate,
              CommunityPayWays: this.configData.CommunityPayWay.map((val) => {
                return {
                  ConfigCommunityPayWayId: val.Id,
                  ConfigHandlingFeeModeEnumName: val.ConfigHandlingFeeModeId,
                  Switch: val.Switch
                }
              })
            }
            apiBillservice.Config.PutCommunitySettingForm(
              requestData
            ).then((res) => {
              this.configDataOri = _cloneDeep(this.configData)
              this.editConfig = false
              this.pageLoading = false
              this.$message({
                message: '修改社區基本設定成功',
                type: 'success'
              })
              this.getConfigData()
              this.getPeriodList(false)
            }).catch((err) => {
              this.pageLoading = false
              this.$message({
                message: '修改社區基本設定失敗，請稍後再試',
                type: 'warning'
              })
              console.log(err.response)
            })
          } else {
            this.editConfig = false
          }
        } else {
          this.$message({
            showClose: true,
            message: '修改社區基本設定失敗 - 請確認各欄位均已填妥',
            type: 'warning'
          })
          return false
        }
      })
    },
    handlePreview (page) { // 預覽繳費單bill receipt
      let routeData
      switch (page) {
        case 'bill':
          routeData = this.$router.resolve({
            name: 'PrintBillPreview',
            params: this.feeType
          })
          break
        case 'receipt':
          routeData = this.$router.resolve({
            name: 'PrintReceiptPreview',
            params: this.feeType
          })
          break
      }
      window.open(routeData.href, '_blank')
    },
    resetForm (formName) { // 重置表格資料
      this.configData = _cloneDeep(this.configDataOri)
      this.$refs[formName].resetFields()
    },
    isDataEqual (a, b) {
      return _isEqual(a, b)
    }
  }
}
</script>

<style lang="sass" scoped>
.collapse-enter-active,
.collapse-leave-active
  transition: all 0.3s ease
  overflow: hidden

.collapse-enter,
.collapse-leave-to
  max-height: 0

.collapse-enter-to,
.collapse-leave
  max-height: 700px

#fee_main
  +mainLayer
  text-align: center
  padding: 50px 0 10px
  ::v-deep .el-dialog
    +basicDialog
    .el-checkbox__label
      font-size: map-get($fontSize,small)
      vertical-align: middle
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after
      border-color: $subFontColor
    .el-checkbox__input.is-disabled + span.el-checkbox__label
      color: $subFontColor
    .basicSetting
      width: 100%
      .block
        display: flex
        flex-wrap: wrap
        &:first-child
          border-bottom: dashed 1px $borderDark1
        &:not(:first-child)
          margin-top: 15px
        .block_left
          width: 20%
        .block_right
          display: flex
          flex-wrap: wrap
          width: 80%
      .down
        border-top: dashed 1px $borderDark1
      .independent
        .el-form-item__label
          float: none
          display: block
          text-align: left
          margin-bottom: 4px
        .click-label
          cursor: pointer
          .icon-arrow-right2
            display: inline-block
            transition: transform 0.3s ease-in-out
            &.rotate
              transform: rotate(90deg)
  .list_info
    display: flex
    justify-content: flex-end
    align-items: center
    margin: 20px 0
    .result
      margin: 0 10px
  .tabContent

</style>
